import Image from 'next/image';
import React from 'react';

// TODO: Get this type from VM once its added
export type VehicleFare = {
  vehicleId: number;
  fare: string;
  discount?: string;
  goldDiscount?: string;
  withoutDiscount?: string;
};

export interface FareDetailsProps {
  vehicleFareDetails: VehicleFare;
  isExpanded?: boolean;
}

/**
 * TODO: Breakdown the fare details into base components
 */

const FareDetails: React.FC<FareDetailsProps> = ({
  vehicleFareDetails: {
    vehicleId,
    fare,
    discount,
    goldDiscount,
    withoutDiscount,
  },
  isExpanded,
}) => {
  return (
    <div
      id={`${vehicleId}-fare-details`}
      className="flex flex-col h-full justify-self-center items-end space-y-2"
    >
      <div className="flex items-center space-x-2">
        {isExpanded ? (
          <div className="flex items-center space-x-2 rounded-3xl bg-[#0E8155] text-[#F4F5F6] text-lg px-2.5 py-1">
            <Image
              src={'/assets/discount-tag.svg'}
              height={20}
              width={20}
              alt="discount"
            />
            <div>₹{Number(withoutDiscount) - Number(fare)} off</div>
          </div>
        ) : (
          <>
            {discount && (
              <Image
                src={'/assets/discount-tag.svg'}
                height={20}
                width={20}
                alt="discount"
              />
            )}
            {goldDiscount && (
              <Image
                src={'/assets/porter-gold-tag.svg'}
                height={20}
                width={20}
                alt="discount"
              />
            )}
          </>
        )}

        <div id={`${vehicleId}-fare`} className="font-bold text-2xl">
          ₹{fare}
        </div>
      </div>
      {withoutDiscount && (
        <div
          id={`${vehicleId}-fare-without-discount`}
          className="font-medium text-xl text-[#9499A3] line-through"
        >
          ₹{withoutDiscount}
        </div>
      )}
    </div>
  );
};

export default FareDetails;
